import React, { useState } from 'react';
import { CalendarIcon, PercentIcon, InfoIcon, FileTextIcon } from 'lucide-react';
export function QuoteDetailsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    quoteTitle: initialData.quoteTitle || '',
    quoteDescription: initialData.quoteDescription || '',
    relatedPivot: initialData.relatedPivot || '',
    pivotSerialNumber: initialData.pivotSerialNumber || '',
    discount: initialData.discount || 0,
    urgency: initialData.urgency || 'normal',
    notes: initialData.notes || '',
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    onUpdate({
      ...formData,
      [name]: value
    });
  };
  return <div className="space-y-6" data-id="element-5256">
      {/* Header */}
      <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-5 rounded-t-xl shadow-sm" data-id="element-5257">
        <div className="flex items-center" data-id="element-5258">
          <div className="p-2 mr-3 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5259">
            <FileTextIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5260" />
          </div>
          <div data-id="element-5261">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-5262">
              Quote Details
            </h2>
            <p className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-5263">
              Provide the basic information for this quote
            </p>
          </div>
        </div>
      </div>
      {/* Basic Information */}
      <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5264">
        <div className="flex items-center mb-4" data-id="element-5265">
          <FileTextIcon size={20} className="text-blue-600 dark:text-blue-400 mr-2" data-id="element-5266" />
          <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5267">
            Basic Information
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-5268">
          <div data-id="element-5269">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5270">
              Quote Title
            </label>
            <input type="text" name="quoteTitle" value={formData.quoteTitle} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="E.g. Replacement Parts for Valley Center Pivot" data-id="element-5271" />
          </div>
          <div data-id="element-5272">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5273">
              Urgency
            </label>
            <select name="urgency" value={formData.urgency} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%236B7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5274">
              <option value="low" data-id="element-5275">Low Priority</option>
              <option value="normal" data-id="element-5276">Normal</option>
              <option value="high" data-id="element-5277">High Priority</option>
              <option value="critical" data-id="element-5278">Critical/Emergency</option>
            </select>
          </div>
        </div>
        <div className="mb-4" data-id="element-5279">
          <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5280">
            Quote Description
          </label>
          <textarea name="quoteDescription" value={formData.quoteDescription} onChange={handleChange} rows={3} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Provide a brief description of what these spare parts are for" data-id="element-5281"></textarea>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5282">
          <div data-id="element-5283">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5284">
              Related Pivot/Machine
            </label>
            <input type="text" name="relatedPivot" value={formData.relatedPivot} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="E.g. Valley 8000 series" data-id="element-5285" />
          </div>
          <div data-id="element-5286">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5287">
              Serial Number (if applicable)
            </label>
            <input type="text" name="pivotSerialNumber" value={formData.pivotSerialNumber} onChange={handleChange} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter machine serial number" data-id="element-5288" />
          </div>
        </div>
      </div>
      {/* Discount and Notes */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-5289">
        {/* Discount Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5290">
          <div className="flex items-center mb-4" data-id="element-5291">
            <div className="p-2 mr-2 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5292">
              <PercentIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5293" />
            </div>
            <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5294">
              Discount
            </h3>
          </div>
          <div data-id="element-5295">
            <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1" data-id="element-5296">
              Discount Percentage (%)
            </label>
            <div className="flex items-center" data-id="element-5297">
              <input type="range" name="discount" min="0" max="50" step="1" value={formData.discount} onChange={handleChange} className="w-full h-2 bg-gray-200 dark:bg-gray-700 rounded-lg appearance-none cursor-pointer accent-blue-500" data-id="element-5298" />
              <span className="ml-3 text-gray-900 dark:text-white font-medium min-w-[3rem] text-right" data-id="element-5299">
                {formData.discount}%
              </span>
            </div>
            <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-5300">
              <span data-id="element-5301">0%</span>
              <span data-id="element-5302">25%</span>
              <span data-id="element-5303">50%</span>
            </div>
          </div>
          <div className="mt-4 bg-gray-50 dark:bg-gray-750 rounded-lg p-4 border border-gray-200 dark:border-gray-700" data-id="element-5304">
            <div className="flex items-start" data-id="element-5305">
              <InfoIcon size={18} className="text-blue-600 dark:text-blue-400 mr-2 mt-0.5" data-id="element-5306" />
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-5307">
                Discounts are applied to the subtotal before shipping and taxes.
                Maximum discount is limited to 50%.
              </p>
            </div>
          </div>
        </div>
        {/* Notes Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl p-5 border border-gray-200 dark:border-gray-700 shadow-sm" data-id="element-5308">
          <div className="flex items-center mb-4" data-id="element-5309">
            <div className="p-2 mr-2 bg-blue-100 dark:bg-blue-900/40 rounded-lg" data-id="element-5310">
              <CalendarIcon size={20} className="text-blue-600 dark:text-blue-400" data-id="element-5311" />
            </div>
            <h3 className="text-gray-900 dark:text-white font-medium" data-id="element-5312">
              Additional Notes
            </h3>
          </div>
          <div data-id="element-5313">
            <textarea name="notes" value={formData.notes} onChange={handleChange} rows={5} className="w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2.5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter any additional notes, special requirements or instructions..." data-id="element-5314"></textarea>
          </div>
        </div>
      </div>
    </div>;
}